export enum VehicleChassisTypeEnum {
  UNDEFINED = 0,
  SEDAN = 1,
  MINIVAN = 2,
  ATV = 3,
  LIGHT_VAN = 4,
  VAN = 5,
  BOX_TRUCK = 6,
  SCOOTER = 20,
  MOTORBIKE = 21,
}

export const VehicleChassisLabel: Record<VehicleChassisTypeEnum, string> = {
  [VehicleChassisTypeEnum.UNDEFINED]: 'common.vehicleChassis.UNDEFINED',
  [VehicleChassisTypeEnum.SEDAN]: 'common.vehicleChassis.SEDAN',
  [VehicleChassisTypeEnum.MINIVAN]: 'common.vehicleChassis.MINIVAN',
  [VehicleChassisTypeEnum.ATV]: 'common.vehicleChassis.ATV',
  [VehicleChassisTypeEnum.LIGHT_VAN]: 'common.vehicleChassis.LIGHT_VAN',
  [VehicleChassisTypeEnum.VAN]: 'common.vehicleChassis.VAN',
  [VehicleChassisTypeEnum.BOX_TRUCK]: 'common.vehicleChassis.BOX_TRUCK',
  [VehicleChassisTypeEnum.SCOOTER]: 'common.vehicleChassis.SCOOTER',
  [VehicleChassisTypeEnum.MOTORBIKE]: 'common.vehicleChassis.MOTORBIKE',
};
